import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { DashboardComponentStrategy, DashboardComponentStrategyStore } from '../models/DashboardComponentStrategy';
import Highcharts from 'projects/gtw-elements/src/app/core/highcharts-init';

@Injectable({
    providedIn: 'root'
})
export class StrategyService {

    private strategyStore: DashboardComponentStrategyStore = {
        aggregateByCategory: {
            inputs: [{ value: 'series_by', name: 'Series', selectionMode: 'single' },
            { value: 'categories_by', name: "Categories", selectionMode: 'single' },
            { value: 'values_by', name: 'Values By', selectionMode: 'single' }],
            displayName:"Plot data points by Category for mutiple series",
            value:"aggregateByCategory",
            func: this.aggregateByCategory
        },
        aggregateByCategoryWithoutSeries: {
            inputs: [{ value: 'categories_by', name: "Categories", selectionMode: 'single' },
            { value: 'values_by', name: 'Values By', selectionMode: 'single' },
            { value: 'enable_drilldown', name: 'Enable Drilldown', selectionMode: 'toggle', optional: true }],
            displayName:"Plot data points by Category without Series",
            value:"aggregateByCategoryWithoutSeries",
            func: this.aggregateByCategoryWithoutSeries
        },
        groupBusinessBy: {
            inputs: [{ value: 'businessNameAttr', name: 'Business Name Attribute', selectionMode: 'single' },
            { value: 'businessCodeAttr', name: 'Business Code Attribute', selectionMode: 'single' },
            { value: 'groupAmountsBy', name: 'Group Amounts By', selectionMode: 'single' },
            { value: 'amountsAttr', name: 'Amounts By', selectionMode: 'single' }],
            displayName:"Build Standard Business Group",
            value:"groupBusinessBy",
            func: this.groupBusinessBy
        },
        rawDataToSeries: {
            inputs: [],
            displayName:"Plug raw data to series",
            value:"rawDataToSeries",
            func: this.rawDataToSeries
        },
        showSheetData: {
            inputs: [],
            displayName:"Get Raw Data",
            value:"showSheetData",
            func: this.showSheetData
        },
        singleSeriesChart: {
            inputs: [{ value: 'series_by', name: 'Series', selectionMode: 'single' },
            // { value: 'categories_by', name: "Categories", selectionMode: 'single' },
            { value: 'values_by', name: 'Values By', selectionMode: 'single' },
            { value: 'colors_by', name: 'Colors By', selectionMode: 'single', optional: true}
        ],
            displayName:"Plot data points in a single series with no categories",
            value:"singleSeriesChart",
            func: this.singleSeriesChart
        },
        horizontalBizzTreeMap: {
            inputs: [{ value: 'series_by', name: 'Series', selectionMode: 'single' },
            { value: 'values_by', name: 'Values By', selectionMode: 'single' }],
            displayName:"Build Standard Business Tree Map",
            value:"horizontalBizzTreeMap",
            func: this.horizontalBizzTreeMap
        },
        buildRegularTreeMap: {
            inputs: [{ value: 'series_by', name: 'Series', selectionMode: 'single' },
            { value: 'values_by', name: 'Values By', selectionMode: 'single' },
            { value: 'drilldown_series_by', name: 'Drill Down By', selectionMode: 'single' }],
            displayName:"Build Standard Highcharts Tree Map",
            value:"buildRegularTreeMap",
            func: this.buildRegularTreeMap
        },
        buildCombinationChart: {
            inputs: [],
            displayName:"Combine 2 components into one",
            value:"buildCombinationChart",
            func: this.buildCombinationChart
        },
        aggregateByColumn: {
            inputs: [{ value: 'aggregateBy', name: 'Aggregate By', selectionMode: 'single' }],
            displayName:"Sum of Column",
            value:"aggregateByColumn",
            func: this.aggregateByColumn
        },
        aggregatePercentByColumn: {
            inputs: [{ value: 'aggregateBy', name: 'Aggregate By', selectionMode: 'single' },
            { value: 'percentBy', name: 'Percent By', selectionMode: 'single' }],
            displayName:"Percentage of Column by Column",
            value:"aggregatePercentByColumn",
            func: this.aggregatePercentByColumn
        },
        filterDataAndAggregate: {
            inputs: [
                { value: 'filterColumn', name: 'Filter Column', selectionMode: 'single' },
                { value: 'filterBy', name: 'Filter By',  type:'input' },
                { value: 'aggregateBy', name: 'Aggregate By', selectionMode: 'single' },
            ],
            displayName:"Filter Data and Aggregate",
            value:"filterDataAndAggregate",
            func: this.filterDataAndAggregate
        },
        applyCustomForumlaOnColumns: {
            inputs: [
                { value: 'formula', name: 'Formula',  type:'input' }
            ],
            displayName:"Apply Custom Formula with Columns as placeholders",
            value:"applyCustomForumlaOnColumns",
            func: this.applyCustomForumlaOnColumns
        },
        applyCustomForumlaOnRows: {
            inputs: [
                { value: 'filterColumn', name: 'Filter Column', selectionMode: 'single' },
                { value: 'valueBy', name: 'Value By', selectionMode: 'single' },
                { value: 'formula', name: 'Formula',  type:'input' }
            ],
            displayName:"Apply Custom Formula with Row Data to Match as Placeholders",
            value:"applyCustomForumlaOnRows",
            func: this.applyCustomForumlaOnRows
        },
        aggregateCategoriesByProps: {
            inputs: [{ value: 'series_by', name: 'Series', selectionMode: 'single' },
            { value: 'categories_by', name: 'Categories', selectionMode: 'multiple' }
            ],
            value:"aggregateCategoriesByProps",
            displayName:"Plot data points with columns as categories for multiple series",
            func: this.aggregateCategoriesByProps
        },
        groupByWithChange: {
            inputs: [{ value: 'group_by', name: 'Group By', selectionMode: 'single' }],
            displayName:"Compare 2 groups in 2 rows with difference in 3rd Row",
            value:"groupByWithChange",
            func: this.groupByWithChange
        },
        aggregateSeriesByProps: {
            inputs: [{ value: 'categories_by', name: 'Categories', selectionMode: 'single' },
            { value: 'series_by', name: 'Series', selectionMode: 'multiple' }],
            displayName:"Plot data points with columns as series for multiple categories",
            value:"aggregateSeriesByProps",
            func: this.aggregateSeriesByProps
        },
        aggregateCategoriesByPropsWithoutSeries: {
            inputs: [
                { value: 'categories_by', name: 'Categories', selectionMode: 'multiple' }
            ],
            displayName:"Plot data points with columns as categories without series",
            value:"aggregateCategoriesByPropsWithoutSeries",
            func: this.aggregateCategoriesByPropsWithoutSeries
        },
        countAllRows: {
            inputs: [
                { value: 'column_by', name: 'Column', selectionMode: 'single' }
            ],
            displayName:"Count Unique Rows by Column",
            value:"countAllRows",
            func: this.countAllRows
        }

    }

    getStrategyFunctionString(strategyName: string): any {
        const func = this.strategyStore[strategyName]["func"];

        if (func) {
            return func.toString();
        }
    }
    getAllStrategies() {
        return this.strategyStore;
    }
    runStrategy(strategyName: string, sheetData: any[], options: any) {
        const data = this.validation(strategyName, sheetData, options);
        if (data.errorMsgs.length > 0) {
            return data;
        }
        return this.strategyStore[strategyName]["func"](sheetData, options);
    }

    getStrategyInputs(strategyName: string, actionKeys: string[], strategySettings: DashboardComponentStrategy) {
        if(!this.strategyStore[strategyName]){
            return [];
        }
        return this.strategyStore[strategyName]["inputs"].map(function (input) {
            return {
                name: input.name,
                selected: strategySettings ? (Array.isArray(strategySettings[input.value]) ?
                    strategySettings[input.value].map(function (key: any) { return { name: key, value: key,LABEL:key,VALUE:key,isChecked:true } }) : []) : [],
                values: actionKeys.map(function (key) { return { name: key, value: key, LABEL:key,VALUE:key } }),
                selectionMode: input.selectionMode,
                key: input.value,
                type:input.type
            }
        })
    }





    private buildCombinationChart(sheetData: any[], options: any) {
        const data = {
            errorMsgs: []
        }
    }


    private buildRegularTreeMap(sheetData: any[], options: any) {
        /**
        *
        * @param  sheetData
        * @param  options
        * @returns {
        *      topLevelData:[],
        *      errorMsgs: [],
        *      drilldown : {}
        * }
        */
        const data:any = {
            errorMsgs: [],
        }

        data.topLevelData = _.map(_.groupBy(sheetData, options.series_by), function (value, i) {
            const isNegative = _.sumBy(value, options.values_by) < 0 ? true : false;
            return {
                name: i,
                value: Math.abs(_.sumBy(value, options.values_by)),
                level: 1,
                drilldown: i,
                isNegative: isNegative
            }
        });

        if (options.drilldown_series_by) {

            data.drilldown = {}


            const drilldownCollection: any = {}
            _.each(_.groupBy(sheetData, options.series_by), function (value, i) {
                drilldownCollection[i] = _.groupBy(value, options.drilldown_series_by);
            });

            data.drilldown.series = _.map(drilldownCollection, function (value, i) {
                const data = [];

                for (const key in value) {
                    const isNegative = _.sumBy(value[key], options.values_by) < 0 ? true : false;
                    data.push({
                        name: key,
                        value: Math.abs(_.sumBy(value[key], options.values_by)),
                        level: 2,
                        isNegative: isNegative
                    })
                }
                return {
                    type: "treemap",
                    id: i,
                    data: data
                }

            })

        }
        return data
    }

    private horizontalBizzTreeMap(sheetData: any[], options: any) {
        const data: any = {
            errorMsgs: []
        }

        data.nodes = _.reverse(_.sortBy(_.map(_.groupBy(sheetData, options.series_by), function (value, i) {
            let isNegative;
            let color;

            let sum = _.sumBy(value, options.values_by);


                if (sum < 0) {
                    isNegative = true;
                    color = '#e86153'//'red'//rgb(249, 63, 63)
                }
                else {
                    isNegative = false;
                    color = '#4eb523'//'green'//rgb(56, 146, 56)
                }



            return {
                name: i,
                fullName: i,
                value: Math.abs(sum),
                isNegative: isNegative,
                color: color
            }


        }), 'value'));

        return data
        // }
    }


    private singleSeriesChart(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      series:[],
         *      errorMsgs: []
         * }
        */
        const data: any = {
            errorMsgs: [],
            sheetDataSafeCopy: sheetData,
            series: [
                {
                    name: "",
                    data: null
                }
            ]
        }
        let colorFlags: any[] = [];

        if(options.colors_by)
            colorFlags = _.uniq(_.map(sheetData, options.colors_by));

        data.series[0].data = _.map(_.groupBy(sheetData, options.series_by), function (seriesData, i) {
            let totalCurrentAmount = _.sumBy(seriesData, options.values_by);
            let isNegative = false;
            if (totalCurrentAmount < 0) {
                isNegative = true;
                totalCurrentAmount = Math.abs(totalCurrentAmount)
            }
            return {
                name: i,
                y: totalCurrentAmount,
                value: totalCurrentAmount,
                color: colorFlags.length > 0 && seriesData.length > 0
                    ? Highcharts.getOptions().colors![colorFlags.indexOf(seriesData[0][options.colors_by])]: null,//only 10 colors available
                isNegative: isNegative,
            }
        });

        // data.series[0].data[0].selected = true;
        // data.series[0].data[0].sliced = true;

        return data
    }


    private aggregateByCategory(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      series:[],
         *      categories:[],
         *      errorMsgs: []
         * }
         */
        const data: any = {
            errorMsgs: [],
            sheetDataSafeCopy: sheetData
        };

        data.categories = _.sortBy(_.keys(_.groupBy(sheetData, options.categories_by)));


        data.series = _.map(_.groupBy(sheetData, options.series_by), function (seriesData, i) {
            const groupByTotal = _.sortBy(_.map(_.groupBy(seriesData, options.categories_by), function (totalData, i) {
                const sum = _.sumBy(totalData, options.values_by);
                return {
                    name: i,
                    y: sum,
                    value: sum
                };
            }), 'name');//always sort by series name

            //adding 0 to non existing categories in same order as categories.
            const nonExistentCategories = _.difference(data.categories, _.map(groupByTotal, function (item) { return item.name }));

            _.each(nonExistentCategories, function (value, key) {

                groupByTotal.splice(data.categories.indexOf(value), 0, {
                    name: value,
                    y: 0,
                    value: 0
                });
            })


            return {
                name: i,
                data: groupByTotal
            }
        });





        return data;
    }

    private aggregateByCategoryWithoutSeries(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      series:[],
         *      categories:[],
         *      errorMsgs: []
         * }
         */
        const data:any = {
            errorMsgs: [],
            sheetDataSafeCopy: sheetData
        };



        data.series = [{name:options.values_by}];

        const groupByTotal = _.sortBy(_.map(_.groupBy(sheetData, options.categories_by), function (totalData, i) {
            const sum = _.sumBy(totalData, options.values_by);
            return {
                name: i,
                y: sum,
                value: sum,
                drilldown:options.enable_drilldown ? i : undefined
            };
        }), 'name');//always sort by series name

        //adding 0 to non existing categories in same order as categories.
        const nonExistentCategories = _.difference(data.categories, _.map(groupByTotal, function (item) { return item.name }));

        _.each(nonExistentCategories, function (value, key) {

            groupByTotal.splice(data.categories.indexOf(value), 0, {
                name: value,
                y: 0,
                value: 0,
                drilldown:options.enable_drilldown ? value : undefined
            });
        })

        data.series[0].data = groupByTotal;

        if(options.enable_drilldown){
            data.drilldown = {series : []};

            _.forEach(sheetData,level1Point =>{
                try{
                    if(typeof level1Point.CHILDREN === "string"){level1Point.CHILDREN = JSON.parse(level1Point.CHILDREN).children}
                }catch(e){}

                let level2Data = _.sortBy(_.map(_.groupBy(level1Point.CHILDREN, options.categories_by), function (totalData, i) {
                    const sum = _.sumBy(totalData, options.values_by);

                    return {
                        name: i,
                        y: sum
                    };
                }), 'name');
                let series = { name:level1Point[options.categories_by],id:level1Point[options.categories_by],data:level2Data};
                data.drilldown.series.push(series);
            })
        }else{
            data.categories = _.sortBy(_.keys(_.groupBy(sheetData, options.categories_by)));
        }

        return data;
    }

    private aggregateCategoriesByProps(sheetData: any[], options: any) {

        const data:any = {
            errorMsgs: [],
        };

        data.categories = options.categories_by;

        data.series = _.map(_.groupBy(sheetData, options.series_by), function (groupedData, key) {

            const categoriesData: any[] = []

            _.each(data.categories, function (category, key) {
                categoriesData.push(_.sumBy(groupedData, category));
            })

            return {
                name: key,
                data: categoriesData
            };
        });

        return data;
    }

    private aggregateCategoriesByPropsWithoutSeries(sheetData: any[], options: any) {

        const data:any = {
            errorMsgs: [],
        };

        data.categories = options.categories_by;

        data.series = [{
            name:'',
            data:[]
        }]

        _.each(data.categories, function (category, key) {
            data.series[0].data.push(_.sumBy(sheetData, category));
        })

        return data;
    }
    // private countAllRows(sheetData: any[],options: any){
    //     return _.uniqBy(sheetData, options.categories_by).length ;
    // }

    private countAllRows(sheetData: any[],options: any){
        const uniqRecords =  _.uniqBy(sheetData, options.column_by) ;


        return uniqRecords && uniqRecords.length;
    }


    private aggregateSeriesByProps(sheetData: any[], options: any){
        const data: any = {
            errorMsgs: [],
        };

        data.categories = [];

        data.series = _.map(options.series_by,function(prop) {
            return {
                name:prop,
                data:[]
            }
        });


        const seriesData = _.groupBy(sheetData, options.categories_by);

        for(const key in seriesData) {

            _.each(options.series_by, function (series_by, index) {
                const series = _.find(data.series,["name",series_by]);
                series.data.push(_.sumBy(seriesData[key], series_by));
            })

            data.categories.push(key);

        };

        return data;
    }


    private groupByWithChange(sheetData: any[], options: any) {
        const groupedDataTop2 = _.slice(_.reverse(_.sortBy(_.map(_.groupBy(sheetData, options.group_by), function (groupedData, key) {
            const dataObj: any = {};
            dataObj[options.group_by] = key;

            _.keys(groupedData[0]).forEach(function (value, key) {
                if (typeof groupedData[0][value] === "number" && value !== 'TAX_YEAR')
                    dataObj[value] = _.sumBy(groupedData, value);
            })

            return dataObj;
        }), options.group_by)), 0, 2);

        const changeRow: any = {};
        changeRow[options.group_by] = "change";

        _.forIn(groupedDataTop2[0], function (value, key) {
            if (typeof groupedDataTop2[0][key] === "number" && key !== 'TAX_YEAR') {
                //changeRow[key] = groupedDataTop2[1][key] - groupedDataTop2[0][key];
                if (groupedDataTop2 && groupedDataTop2[1] != undefined) {
                    changeRow[key] = groupedDataTop2[1][key] - groupedDataTop2[0][key];
                } else {
                    changeRow[key] = groupedDataTop2[0][key];
                }
            }
        })

        groupedDataTop2.push(changeRow);

        return groupedDataTop2;
    }

    private rawDataToSeries (sheetData: any[],options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
            *      series: [{
            *           data:[]
            *       }]
            * }
            */

            return {
                series:[
                   { data: _.map(sheetData,function(obj){
                                return   _.transform(obj, function (result:any, val, key:string) {
                                            result[key.toLowerCase()] = val;
                                        })
                            })
                    }
                ]
            };
    }


    private showSheetData(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      sheetData: []
         * }
         */
        return sheetData;
    }


    private aggregateByColumn(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      value
         * }
         */
        if(!options.aggregateBy){
            return '';
        }
        return _.sumBy(sheetData, options.aggregateBy);
    }
    private aggregatePercentByColumn(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      value
         * }
         */
        if(!options.aggregateBy){
            return '';
        }

        const numeratorAggregate = _.sumBy(sheetData, options.aggregateBy);
        const denominatorAggregate = _.sumBy(sheetData, options.percentBy);

        if(denominatorAggregate === 0){
            return 'Infinity';
        }

        return (numeratorAggregate/denominatorAggregate) * 100;
    }

    private filterDataAndAggregate(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      value
         * }
         */
        if(!options.filterColumn || !options.filterBy || !options.aggregateBy){
            return '';
        }

        const filteredData = _.filter(sheetData,[options.filterColumn,options.filterBy]);

        const value = _.sumBy(filteredData,options.aggregateBy);


        return value;
    }

    private applyCustomForumlaOnColumns(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
         *      value
         * }
         */

        if(!options.formula){
            return '';
        }

        const tokens: any = {};
        let formula = options.formula;//had angular.copy here.TODO: investigate if we need it.

        formula.replace(/\{(.*?)}/g,function(tokenWithBrackets:string,token:string) {//find better way than replace

            tokens[token].token = token;
            return tokenWithBrackets;
        })

        for(const token in tokens){
            tokens[token].aggregatedValue = _.sumBy(sheetData,token);
        }

        formula = formula.replace(/\{(.*?)}/g,function(tokenWithBrackets:string,token:string) {
            return tokens[token].aggregatedValue;
        })

        try{
            return formula;//$rootScope.$eval(formula);
        }catch{
            return 'error';
        }

    }
    private applyCustomForumlaOnRows(sheetData: any[], options: any) {
        /**
         *
         * @param  sheetData
         * @param  options
         *
         * @returns {
            *      value
            * }
            */

        if(!options.formula || !options.filterColumn || !options.valueBy){
            return '';
        }

        const tokens: any = {};
        let formula = options.formula;//angular.copy()TODO: investigate if we need it.

        formula.replace(/\{'(.*?)'}/g,function(tokenWithBrackets: string,token:string) {//find better way than replace
            tokens[token] = {};
            tokens[token].token = token;
            return tokenWithBrackets;
        })

        for(const token in tokens){

            const filteredData = _.filter(sheetData,[options.filterColumn,token])
            tokens[token].aggregatedValue = _.sumBy(filteredData,options.valueBy);
        }

        formula = formula.replace(/\{'(.*?)'}/g,function(tokenWithBrackets: string,token:string) {
            return tokens[token].aggregatedValue;
        })

        try{
            return formula;//$rootScope.$eval(formula);
        }catch{
            return 'error';
        }

    }

    private groupBusinessBy(sheetData: any[], options: any) {
    /**
     *
     * @param  sheetData
     * @param  options
     *
     * @returns {
                    id,
                    name,
                    value,
                    data:{
                        amount,
                        color,
                        isNegative
                    },
                    selected= false

        * }
        */
        sheetData = addColorToFSIData(sheetData, options.groupAmountsBy);

        return _.map(_.groupBy(sheetData, options.businessNameAttr), function (parent_me, parent_me_name) {
            const parent_me_revenue: any = {}
            _.each(_.groupBy(parent_me, options.groupAmountsBy), function (basket_code, basket_code_name) {
                if (!_.keys(parent_me_revenue).includes(basket_code_name)) {
                    parent_me_revenue[basket_code_name] = {};
                }
                parent_me_revenue[basket_code_name]['amount'] = Math.abs(_.sumBy(basket_code, options.amountsAttr));
                parent_me_revenue[basket_code_name]['color'] = basket_code[0]['COLOR'];
                parent_me_revenue[basket_code_name]['isNegative'] = _.sumBy(basket_code, options.amountsAttr) < 0 ? true : false;


            });
            return {
                id: parent_me[0][options.businessCodeAttr],
                name: parent_me_name,
                value: parent_me[0][options.businessCodeAttr],
                data: parent_me_revenue,
                selected: false
            }
        })


        function addColorToFSIData(sheetData: any[], groupBy: any) {
            const diamondColor = ['darkblue', 'green', 'orange','violet' , 'indigo' , 'yellow' , 'brown' , 'lightblue'];
            let counter = 0;
            const groupedData = _.groupBy(sheetData, groupBy);
            for (const key in groupedData) {

                for (let i = 0; i < groupedData[key].length; i++) {
                    groupedData[key][i]['COLOR'] = diamondColor[counter];
                }
                counter++;
            }

            return sheetData;
        }
    }

    /**
     *
     * @param  sheetData
     * @param  options
     *
     * @returns {
     *      errorMsgs: []
     * }
     */
    private validation(strategyName: string, sheetData: any[], options: any) {
        const data: any = {
            errorMsgs: []
        };
        if (!strategyName) {
            data.errorMsgs.push("Please select strategy");
        } else if (!this.strategyStore[strategyName]) {
            data.errorMsgs.push("Invalid Strategy");
        } else if (!this.strategyStore[strategyName].inputs) {
            data.errorMsgs.push("Inputs are not defined for strategy '" + strategyName + "' in strategy factory.");
        } else if (!this.strategyStore[strategyName].func) {
            data.errorMsgs.push("No function is defined for strategy '" + strategyName + "' in strategy factory.");
        }
        else {
            const safeOptions = options || {};

            _.each(this.strategyStore[strategyName].inputs, function (input, key) {
                if (input.optional) {
                    return;
                }

                const value = safeOptions[input.value];

                if (input.selectionMode === 'single' && !value) {
                    data.errorMsgs.push("Please select '" + input.name + "' in strategy settings");
                    return;
                }

                if (input.selectionMode === 'multiple' && (!value || value.length === 0)) {
                    data.errorMsgs.push("Please select atleast one '" + input.name + "' in strategy settings");
                    return;
                }
            })
        }

        return data;
    }
}
